<h2 mat-dialog-title>
  @if (data.kohde.tyyppi === 'tiimi') {
    @if (data.kohde.rooli === 'esihenkilo') {
      Lisää esihenkilö - {{ data.kohde.tiimiNimi }}
    } @else {
      Lisää jäsen - {{ data.kohde.tiimiNimi }}
    }
  } @else {
    Lisää esihenkilö - {{ data.kohde.kokonaisuusNimi }}
  }
</h2>
<mat-dialog-content>
  <form novalidate>
    <mat-form-field style="width: 100%">
      <mat-label>Henkilö</mat-label>
      <input type="text" matInput [formField]="lomake.kirjanpitaja" [matAutocomplete]="kirjanpitajaAuto" />
      <mat-autocomplete #kirjanpitajaAuto="matAutocomplete" [displayWith]="kirjanpitajaDisplay">
        @for (kirjanpitaja of suodatetutKirjanpitajatObservable | async; track kirjanpitaja.avain) {
          <mat-option [value]="kirjanpitaja">
            {{ kirjanpitaja.etunimi }} {{ kirjanpitaja.sukunimi }} <span style="color: rgba(0, 0, 0, 0.4); margin-left: 8px">{{ kirjanpitaja.email }}</span>
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>

    <mat-form-field style="width: 100%">
      <mat-label>Alkupäivä</mat-label>
      <input matInput [matDatepicker]="dp" [formField]="lomake.alkupaiva" />
      <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
      <mat-datepicker #dp></mat-datepicker>
    </mat-form-field>

    @if (data.kohde.tyyppi === 'tiimi') {
      <div>
        <mat-checkbox [formField]="lomake.primary">Ensisijainen tiimi (primary) tälle henkilölle</mat-checkbox>
      </div>
    }
  </form>
  @if (virhe) {
    <div class="red-text" style="margin-top: 8px">{{ virhe }}</div>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <app-secondary-button style="margin-right: 10px" (click)="peruuta()" actionId="Peruuta">Peruuta</app-secondary-button>
  <app-primary-button (click)="tallenna()" actionId="Lisää jäsen" [actionContext]="[data.kohde, lomake.kirjanpitaja().value(), lomake.alkupaiva().value(), lomake.primary().value()]" [disabled]="!lomake().valid()">Lisää</app-primary-button>
</mat-dialog-actions>
